import { useAppDispatch, useAppSelector } from '@platform/state/hooks';
import { selectToasts } from '@platform/state/selectors';
import { toastDismissed } from '@platform/state/slices/uiSlice';

/** Спливні повідомлення зі стану ui; клік закриває. */
export function Toasts() {
  const toasts = useAppSelector(selectToasts);
  const dispatch = useAppDispatch();
  if (!toasts.length) return null;
  return (
    <div className="toasts">
      {toasts.map((t) => (
        <div key={t.id} className={`toast is-${t.kind}`} onClick={() => dispatch(toastDismissed(t.id))}>{t.text}</div>
      ))}
    </div>
  );
}
